export enum Actions {
  TOOGLE_FEATURE = '@FEATURECONTROL/TOOGLE_FEATURE'
}
